import api from "../../api";

export const getCourses = async (query?: string) => {
  if (query) {
    const { data } = await api.get(`manager/course?${query}`);
    return data
  } else {
      const { data } = await api.get('manager/course/');
      return data
  }
}

export const newCourse = async (params: any) => {
  const { data } = await api.post(`manager/course/`, params);
  return data
}

export const getCourse = async (idCourse: any) => {
  const { data } = await api.get(`manager/course/${idCourse}`);
  return data
}

export const updateCourse = async (idCourse: any, params: any) => {
  const { data } = await api.put(`manager/course/${idCourse}`, params);
  return data
}

export const changeStatusCourse = async (idCourse: any, status: boolean) => {
  const { data } = await api.patch(`manager/course/${idCourse}`, {is_active: status});
  return data
}

export const publishCourse = async (idCourse: any, statusPublish: boolean) => {
  const { data } = await api.patch(`manager/course/publish/${idCourse}`, {publish: statusPublish});
  return data
}

export const deleteCourse = async (idCourse: any) => {
  const { data } = await api.delete(`manager/course/${idCourse}`);
  return data
}

export const newPhase = async (params: any) => {
  const { data } = await api.post(`manager/step/`, params);
  return data
}

export const editPhase = async (idPhase: number, params: any) => {
  const { data } = await api.put(`manager/step/${idPhase}`, params);
  return data
}

export const getPhase = async (idPhase: number) => {
  const { data } = await api.get(`manager/step/${idPhase}`);
  return data
}

export const removePhase = async (idPhase: number) => {
  const { data } = await api.delete(`manager/step/${idPhase}`);
  return data
}

export const getDisciplinesToSync = async (courseId: any) => {
  const { data } = await api.get(`manager/short_discipline/publish/`, {params: { 'course': courseId }});
  return data
}

export const syncDisciplines = async (courseId: any, params: any) => {
  const { data } = await api.post(`manager/course/${courseId}/add/discipline/`, params);
  return data
}

export const removeDiscipline = async (courseId: any, disciplineId: any) => {
  const { data } = await api.post(`manager/course/${courseId}/remove/discipline/${disciplineId}/`);
  return data
}

export const getCourseDisiplineLeaf = async(disciplineId: any) => {
  const { data } = await api.get(`manager/course/discipline/leaf/${disciplineId}`);
  return data
}